import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

export type TrackExitIntentPromptViewedPayload = TrackingPayload & {
    catalogId: number;
    itemId: number;
    lotTitle: string;
    platform: 'desktop' | 'mobileWeb';
};

export const trackExitIntentPromptViewedAnalytics = (payload: TrackExitIntentPromptViewedPayload) => {
    track(TrackingEvents.Item.ExitIntentPromptViewed, payload);
};

export const useTrackExitIntentPromptViewedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ catalogId, itemId, lotTitle, platform }: Omit<TrackExitIntentPromptViewedPayload, 'pageName' | 'url'>) => {
            trackExitIntentPromptViewedAnalytics({
                catalogId,
                itemId,
                lotTitle,
                pageName: getAmplitudePageNameFromPath(pathname),
                platform,
                url,
            });
        },
        [pathname, url]
    );
};
